var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconGoogleChrome = function SvgIconGoogleChrome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_38227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 36.1578C30.6274 36.1578 36 30.7853 36 24.1578C36 17.5304 30.6274 12.1578 24 12.1578C17.3726 12.1578 12 17.5304 12 24.1578C12 30.7853 17.3726 36.1578 24 36.1578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.1631H44.7812C42.6754 8.51451 39.6461 5.48463 35.9978 3.37813C32.3496 1.27164 28.2111 0.162792 23.9984 0.163086C19.7857 0.16338 15.6473 1.27281 11.9994 3.37981C8.35147 5.48681 5.32258 8.51712 3.21729 12.166L13.6079 30.1631L13.6172 30.1607C12.5602 28.338 12.0024 26.2688 12 24.1618C11.9977 22.0548 12.5508 19.9843 13.6037 18.1592C14.6566 16.3341 16.172 14.8189 17.9973 13.7662C19.8225 12.7135 21.893 12.1605 24 12.1631Z",
    fill: "url(#paint0_linear_275_38227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 33.6631C29.2467 33.6631 33.5 29.4098 33.5 24.1631C33.5 18.9164 29.2467 14.6631 24 14.6631C18.7533 14.6631 14.5 18.9164 14.5 24.1631C14.5 29.4098 18.7533 33.6631 24 33.6631Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3912 30.1659L24.0006 48.163C28.2133 48.1636 32.3519 47.0551 36.0003 44.9488C39.6486 42.8426 42.6782 39.813 44.7842 36.1645C46.8903 32.5161 47.9987 28.3774 47.9979 24.1648C47.9972 19.9521 46.8873 15.8138 44.7799 12.1661H23.9988L23.9963 12.1754C26.1034 12.1714 28.1742 12.7229 30.0002 13.7743C31.8261 14.8258 33.3426 16.34 34.3967 18.1644C35.4509 19.9888 36.0054 22.0589 36.0044 24.1659C36.0035 26.273 35.447 28.3425 34.3912 30.1659Z",
    fill: "url(#paint1_linear_275_38227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6086 30.1662L3.21803 12.1691C1.11115 15.8171 0.001866 19.9555 0.001709 24.1682C0.00155201 28.3809 1.11053 32.5194 3.21713 36.1675C5.32374 39.8157 8.35371 42.8449 12.0024 44.9506C15.6511 47.0563 19.7898 48.1643 24.0025 48.1631L34.3931 30.166L34.3864 30.1592C33.3364 31.9859 31.8233 33.5036 29.9998 34.5592C28.1762 35.6147 26.1066 36.1709 23.9996 36.1716C21.8925 36.1723 19.8225 35.6175 17.9982 34.5632C16.174 33.5089 14.6599 31.9922 13.6086 30.1662Z",
    fill: "url(#paint2_linear_275_38227)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_38227",
    x1: 3.21729,
    y1: 15.1631,
    x2: 44.7812,
    y2: 15.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_38227",
    x1: 20.7218,
    y1: 47.8421,
    x2: 41.5038,
    y2: 11.8467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_275_38227",
    x1: 26.5981,
    y1: 46.6646,
    x2: 5.81613,
    y2: 10.6691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_38227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.163086)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconGoogleChrome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-google-chrome.3f1acb085769450f19179b4b494c015c.svg";